import { Link, NavLink, useLocation } from "react-router-dom";
import { Radar, Menu, X } from "lucide-react";
import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";

const NAV_ITEMS = [
  { label: "Home", to: "/" },
  { label: "Pricing", to: "/pricing" },
  { label: "Security", to: "/security" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export default function PublicHeader() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  const linkBase =
    "text-[12px] font-mono-data tracking-wider uppercase transition-colors";

  return (
    <header
      data-testid="public-header"
      className="sticky top-0 z-40 border-b border-[#1F1F1F] bg-[#0A0A0A]/90 backdrop-blur supports-[backdrop-filter]:bg-[#0A0A0A]/70"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-8 h-14 flex items-center gap-6">
        <Link to="/" className="flex items-center gap-3 group" data-testid="public-header-brand">
          <div className="relative w-7 h-7 flex items-center justify-center rounded-sm border border-[#262626] bg-[#141414]">
            <Radar className="w-3.5 h-3.5 text-[#0A84FF]" strokeWidth={1.6} />
          </div>
          <span className="font-display font-semibold text-white tracking-tight text-sm">RADAR</span>
          <span className="hidden lg:inline kpi-label">Account Intelligence</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1 ml-4">
          {NAV_ITEMS.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`pubnav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `${linkBase} px-3 py-1.5 rounded-sm ${
                  isActive && loc.pathname !== "/"
                    ? "text-white bg-[#141414] border border-[#262626]"
                    : "text-[#A3A3A3] hover:text-white"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2">
          <Link
            to={user ? "/" : "/login"}
            data-testid="public-header-cta"
            className="h-9 px-4 rounded-sm bg-[#0A84FF] hover:bg-[#409CFF] text-white font-medium text-[12px] tracking-tight transition-colors inline-flex items-center"
          >
            {user ? "Open app" : "Sign in"}
          </Link>
          <button
            type="button"
            data-testid="public-header-menu-btn"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
            className="md:hidden h-9 w-9 inline-flex items-center justify-center rounded-sm border border-[#262626] bg-[#141414] text-white"
          >
            {open ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden border-t border-[#1F1F1F] bg-[#0A0A0A]" data-testid="public-header-mobile">
          <div className="max-w-[1600px] mx-auto px-6 py-3 flex flex-col">
            {NAV_ITEMS.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `${linkBase} py-3 border-b border-[#1F1F1F] last:border-b-0 ${
                    isActive ? "text-white" : "text-[#A3A3A3]"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
